/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Businesscreatedbutemailfailed4Inputs */

const en_businesscreatedbutemailfailed4 = /** @type {(inputs: Businesscreatedbutemailfailed4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business created, but the email could not be sent`)
};

const de_businesscreatedbutemailfailed4 = /** @type {(inputs: Businesscreatedbutemailfailed4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business erstellt, aber E-Mail konnte nicht gesendet werden`)
};

/**
* | output |
* | --- |
* | "Business created, but the email could not be sent" |
*
* @param {Businesscreatedbutemailfailed4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const businesscreatedbutemailfailed4 = /** @type {((inputs?: Businesscreatedbutemailfailed4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Businesscreatedbutemailfailed4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_businesscreatedbutemailfailed4(inputs)
	return de_businesscreatedbutemailfailed4(inputs)
});
export { businesscreatedbutemailfailed4 as "businessCreatedButEmailFailed" }